module.exports = __webpack_public_path__ + "static/media/shape_black.c5ea205b.svg";